export default [
  {
    path: "users",
    component: () => import("@/views/dashboard/users/Managment.vue"),
    meta: {
      title: "Gestión de Usuarios",
      breadcrumb: [
        { label: "Inicio", link: "/" },
        { label: "Gestión de usuarios", link: "/dashboard/users" },
      ],
    },
  },
  {
    path: "users/add",
    component: () => import("@/views/dashboard/users/Add"),
    meta: {
      title: "Crear Usuario",
      breadcrumb: [
        { label: "Inicio", link: "/" },
        { label: "Gestión de usuarios", link: "/dashboard/users" },
        { label: "Crear Usuario" },
      ],
    },
  },
  {
    path: "users/edit",
    component: () => import("@/views/dashboard/users/Edit"),
    meta: {
      title: "Editar Usuario",
      breadcrumb: [
        { label: "Inicio", link: "/" },
        { label: "Gestión de usuarios", link: "/dashboard/users" },
        { label: "Editar Usuario" },
      ],
    },
  },
  {
    path: "users/financial_consumers",
    component: () => import("@/views/dashboard/users/FinancialConsumers"),
    meta: {
      title: "Consumidores financieros",
      breadcrumb: [
        { label: "Inicio", link: "/" },
        {
          label: "Consumidores financieros",
          link: "/dashboard/users/FinancialConsumers",
        },
      ],
    },
  },
  {
    path: "users/technical-support",
    component: () =>
      import("@/feature/tecnical_support/presentation/views/tecnical_support"),
    meta: {
      title: "Gestión de solicitudes de Soporte técnico",
      breadcrumb: [
        { label: "Inicio", link: "/" },
        {
          label: "Gestión de solicitudes de Soporte técnico",
          link: "/dashboard/users/technical-support",
        },
      ],
    },
  },
  {
    path: "users/technical-support/:id",
    component: () =>
      import("@/feature/tecnical_support/presentation/views/detail"),
    meta: {
      title: "Soporte técnico",
      breadcrumb: [
        { label: "Inicio", link: "/" },
        {
          label: "Gestión de solicitudes de Soporte técnico",
          link: "/dashboard/users/technical-support",
        },
        {
          label: "Soporte técnico",
          link: "/dashboard/users/technical-support/:id",
        },
      ],
    },
  },
  {
    path: "users/historical",
    component: () =>
      import("@/feature/historical/presentation/views/historical"),
    meta: {
      title: "Histórico de consumidores financieros",
      breadcrumb: [
        { label: "Inicio", link: "/" },
        {
          label: "Histórico de consumidores financieros",
          link: "/dashboard/users/historical",
        },
      ],
    },
  },
  {
    path: "users/historical/:id",
    component: () => import("@/feature/historical/presentation/views/detail"),
    meta: {
      title: "Consumidor financiero",
      breadcrumb: [
        { label: "Inicio", link: "/" },
        {
          label: "Histórico de consumidores financieros",
          link: "/dashboard/users/historical",
        },
        {
          label: "Consumidor financiero",
          link: "/dashboard/users/historical/:id",
        },
      ],
    },
  },
  {
    path: "users/historical/:id/:idDetail",
    component: () =>
      import("@/feature/historical/presentation/views/detail-date"),
    meta: {
      title: "Detalle de consumidor financiero",
      breadcrumb: [
        { label: "Inicio", link: "/" },
        {
          label: "Histórico de consumidores financieros",
          link: "/dashboard/users/historical",
        },
        {
          label: "Consumidor financiero",
          link: "/dashboard/users/historical/:id",
        },
        {
          label: "Detalle de consumidor financiero",
          link: "/dashboard/users/historical/:id/:idDetail",
        },
      ],
    },
  },
];
